import {makeStyles} from "@material-ui/styles";
import React, {Component} from "react";
import Scrollbars from "react-custom-scrollbars";

export const Scrollbar = React.forwardRef((props, ref) => {
  let ps = {...props};
  let viewId = props.viewId;
  let autoHide = props.autoHide;
  let viewClassName = props.viewClassName || "";
  let horizontal = props.horizontal || false;
  let vertical = props.vertical === false ? false : true;
  let overflowY = props.overflowY;
  delete ps.viewId;
  delete ps.viewClassName;
  delete ps.horizontal;
  delete ps.vertical;
  delete ps.overflowY;

  //useStyles修正容器内部元素边框不显示完整的问题
  const useStyles = makeStyles({
    root: props => ({
      paddingRight: 1,
      paddingBottom: 1,
      overflowY: `${overflowY} !important`
    })
  });
  

  let classes = useStyles();
  // let horizontalStyle = horizontal ? { height: "7px", borderRadius: "5px" } : { display: "none" };
  if (autoHide !== false) ps.autoHide = true;
  if (horizontal === false)
    ps.renderTrackHorizontal = props => <div style={{display: "none"}} />;

  if(vertical === false)
    ps.renderTrackVertical = props => <div style={{display: "none"}} />;

  return (
    <Scrollbars
      className="scrollbar"
      {...ps}
      ref={ref}
      renderView={props => (
        <div
          className={`${classes.root} ${viewClassName}`}
          {...props}
          id={viewId || ""}
        />
      )}
      // renderTrackHorizontal={props => <div {...props} style={horizontalStyle} className="track-horizontal" />}
    />
  );
});

Scrollbar.scrollLoadTimes = 0;
Scrollbar.load = (s, top) => {
  s.scrollTop(top);
  Scrollbar.scrollLoadTimes++;

  //效验是否改变
  let posTop = s.getScrollTop();
  let viewHeight = s.getClientHeight();
  if (
    viewHeight >= posTop || //已设置成功
    Scrollbar.scrollLoadTimes >= 10
  ) {
    //超过尝试加载的最大次数
    //满足了3个条件之一，那么删不再加载
    Scrollbar.scrollLoadTimes = 0;
  } else {
    setTimeout(() => {
      Scrollbar.load(s, top);
    }, 50);
  }
};

// export const XYScrollbar = React.forwardRef((props,ref) => <Scrollbars className="scrollbar"  {...props}  ref={ref}
//                             renderTrackVertical={props => <div {...props}  className="track-vertical"/>}
//                             renderTrackHorizontal={props => <div {...props}  className="track-horizontal"/>} />);

//   export default class SpringScrollbar extends React.Component {

//     constructor(props, ...rest) {
//       super(props, ...rest);
//       this.handleSpringUpdate = this.handleSpringUpdate.bind(this);
//     }

//     componentDidMount() {
//       this.springSystem = new SpringSystem();
//       this.spring = this.springSystem.createSpring();
//       this.spring.addListener({ onSpringUpdate: this.handleSpringUpdate });
//     }

//     componentWillUnmount() {
//       this.springSystem.deregisterSpring(this.spring);
//       this.springSystem.removeAllListeners();
//       this.springSystem = undefined;
//       this.spring.destroy();
//       this.spring = undefined;
//     }

//     getScrollTop() {
//       return this.scrollbars.getScrollTop();
//     }

//     getScrollHeight() {
//       return this.scrollbars.getScrollHeight();
//     }

//     getHeight() {
//       return this.scrollbars.getHeight();
//     }

//     scrollTop(top) {
//       const scrollbars = this.scrollbars;
//       const scrollTop = scrollbars.getScrollTop();
//       //const scrollHeight = scrollbars.getScrollHeight();

//       if (Util.type(top) === "object") {
//         let target = top;
//         let el = ReactDOM.findDOMNode(target);
//         let targetRect = el.getBoundingClientRect();

//         let owner = ReactDOM.findDOMNode(this);
//         let ownerRect = owner.getBoundingClientRect();

//         top = targetRect.y - ownerRect.y + scrollTop;
//       }
//       // const val = MathUtil.mapValueInRange(top, 0, scrollHeight, scrollHeight * 0.2, scrollHeight * 0.8);
//       this.spring.setCurrentValue(scrollTop).setAtRest();
//       this.spring.setEndValue(top);
//     }

//     handleSpringUpdate(spring) {
//       const scrollbars = this.scrollbars;
//       const val = spring.getCurrentValue();
//       scrollbars.scrollTop(val);
//     }

//     render() {
//       return (
//         <Scrollbar
//           {...this.props}
//           ref={(r)=> {this.scrollbars=r; }} />
//       );
//     }
// }
